"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CompareTile = require("./CompareTile/CompareTile");
var _MatchHeight = require("../../utils/MatchHeight");
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// UI COMPONENTS

// UTILITIES

var CompareList = exports.CompareList = function CompareList(_ref) {
  var cards = _ref.cards,
    styles = _ref.styles,
    Content = _ref.Content,
    addCard = _ref.addCard,
    removeCard = _ref.removeCard,
    onLearnMore = _ref.onLearnMore,
    columnCount = _ref.columnCount,
    addCardText = _ref.addCardText,
    annualFeeLabel = _ref.annualFeeLabel,
    namespace = _ref.namespace,
    addCardDtm = _ref.addCardDtm,
    linkComponent = _ref.linkComponent;
  return /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeightProvider, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('compare-list', styles.compareList)
  }, Array(columnCount).fill().map(function (_, i) {
    var card = cards[i];
    var key = "CompareTile-".concat(i);
    return /*#__PURE__*/_react["default"].createElement(Content, {
      styles: styles,
      addCard: addCard,
      removeCard: removeCard,
      onLearnMore: onLearnMore,
      card: card,
      addCardText: addCardText,
      annualFeeLabel: annualFeeLabel,
      key: key,
      namespace: (0, _PropertyProvider.NS)(namespace, 'compare-list'),
      indexpos: i,
      addCardDtm: addCardDtm,
      linkComponent: linkComponent
    });
  })));
};
CompareList.defaultProps = {
  styles: {},
  Content: _CompareTile.CompareTile,
  columnCount: 3,
  addCardText: 'Click the plus to add another Card to compare',
  annualFeeLabel: undefined,
  namespace: '',
  addCardDtm: {},
  linkComponent: undefined
};
CompareList.propTypes = {
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  cards: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired,
  Content: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  addCard: _propTypes["default"].func.isRequired,
  removeCard: _propTypes["default"].func.isRequired,
  onLearnMore: _propTypes["default"].func.isRequired,
  columnCount: _propTypes["default"].number,
  addCardText: _propTypes["default"].string,
  annualFeeLabel: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  addCardDtm: _propTypes["default"].objectOf(_propTypes["default"].string),
  linkComponent: _propTypes["default"].func
};